import { render, staticRenderFns } from "./usergroup-renewal-orders.vue?vue&type=template&id=3e6479f8&scoped=true"
import script from "./usergroup-renewal-orders.vue?vue&type=script&lang=js"
export * from "./usergroup-renewal-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6479f8",
  null
  
)

export default component.exports